import React, {useState, useEffect} from 'react';
import useAxiosIntercept from "../../../hooks/useAxiosIntercept";
import responseHandler from "../../../services/responseHandler";

function VerifyPhoneNumber(props) {
    const [phone, setPhone] = useState(props.PhoneNumber == '' || props.PhoneNumber == null ? '' : props.PhoneNumber);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [otp, setOtp] = useState('');
    const [showOtpBlock, setShowOtpBlock] = useState('');
    const axiosPrivate = useAxiosIntercept();
    const [sendOtpTimer, setSendOtpTimer] = useState(-1);
    const validatePhone = () =>{
        let input = phone;
        const phoneNumberRegex = /^\d{8}(\d{2})?$/;
        if (!phoneNumberRegex.test(input)) {

            return false;
        }
        return true;
    }

    useEffect(()=>{
        setPhone(props.PhoneNumber);
    },[props.PhoneNumber])

    const onSubmit = async (e) => {
        //call auth api here
        try{
            const request = {
                comm_value : phone,
                object_type : "partner_add_user"
            };
            const response = await axiosPrivate.post(process.env.REACT_APP_OTP_SEND_URL,request);
            if (response?.data?.status === 200) {
            // setErrorMessage("");
                setErrorMessage("");
                setSendOtpTimer(30);
                setShowOtpBlock(true);
            } else {
                if(response?.data?.response.errors){
                // setErrorMessage(response?.data?.response.errors[0].message);
                    setErrorMessage(response?.data?.response.errors[0].message);
                    setTimeout(()=>{
                        setErrorMessage('');
                    },5000)
                }
                if(response?.data?.message){
                    setErrorMessage(response?.data?.message);
                    setTimeout(()=>{
                        setErrorMessage('');
                    },5000)

                }

                console.log(`API Error: ${JSON.stringify(response?.data?.response)}`);
            }
        }
        catch (err){
            return responseHandler(err, "NETWORK_ERROR");
        }
    };

    const onOtpSubmit = async (event)=>{
        event.preventDefault();
        const request = {
            comm_value: phone,
            object_type: "partner_add_user",
            otp: otp,
        };
        const res = await axiosPrivate.post(process.env.REACT_APP_OTP_VERIFY_URL,request);
        if (res?.error) {
            // setErrorMessage(res?.error?.message);
            setErrorMessage(res?.error?.message);
            setTimeout(()=>{
                setErrorMessage('');
            },5000)

        }

        // else if (res?.data?.message) {
        //     setErrorMessage(res?.data?.message);
        // }
        else {
            if (res?.data?.response?.data?.otp_verified == 1) {
                // setCustomerId()

                // setErrorMessage(res?.data?.message);
                setErrorMessage("");
                setSuccessMessage(res?.data?.message);
                setTimeout(()=>{
                    setSuccessMessage('');
                },5000)

                // console.log(res?.data?.response?.data?.otp_verified);
                setShowOtpBlock(false);
                props.opt(true);
                props.phone(phone);

            } else {
                console.log(res?.response?.error?.message);
                // setErrorMessage("Error try again!!");
                setErrorMessage(res?.data?.message);
                setTimeout(()=>{
                    setErrorMessage('');
                },5000)
                setOtp("");
                props.opt(false);

            }
        }
    }
    useEffect(() => {
        if (sendOtpTimer > 0) {
            setTimeout(() => {
                setSendOtpTimer(prevState => prevState-1);
                }, 1000);
            }
        }, [sendOtpTimer]);

    function handlePhoneChange(event) {
        const inputValue = event.target.value;
        const numbersOnly = inputValue.replace(/[^0-9]/g, ''); // remove non-numeric characters
        const truncated = numbersOnly.slice(0, 10); // truncate to at most 10 digits
        setPhone(truncated);
    }

    const sendOtp = async (e) =>{
        // setErrorMessage("");
        e.preventDefault();
        setOtp('');
        setErrorMessage("");
        props.opt(false);
        let isPhoneValid = validatePhone();
        if(isPhoneValid){

            await onSubmit();
        }
        else{
            setPhone("");
            // setErrorMessage('Phone number invalid');
            setErrorMessage("Phone Number Invalid");
            setTimeout(()=>{
                setErrorMessage('');
            },3000)

        }
    }

    const handleOtpChange = event => {
        const inputValue = event.target.value;

        // check if the input value is a number and has a length of 4
        if (/^\d{0,4}$/.test(inputValue)) {
            setOtp(inputValue);
        }
    };
    return (
            <div className="fieldGroup mobileVerfiy">
                <label>Verify Number</label>
                <span className="mb-12">
                    <input
                        id="phone_number"
                        type="tel"
                        name="phone_number"
                        required
                        maxLength='10'
                        disabled={props.disable || props.isoptValid}
                        minLength='8'
                        pattern="[0-9]"
                        value={phone}
                        autoComplete="nope"
                        onChange={handlePhoneChange}
                        placeholder="Enter Phone Number"
                    />
                    {!props.isoptValid && <>
                        {sendOtpTimer <=0 ?
                            (   sendOtpTimer == -1 ?
                                    <em>
                                        <a href={void(0)}  onClick={sendOtp}> Send OTP</a>
                                    </em>
                                    :
                                    <em >
                                        <a href={void(0)} onClick={sendOtp}> Resend OTP</a>
                                    </em>
                            )
                            :
                            <em>Resend in {sendOtpTimer} secs</em>
                        }
                    </>}

                </span>


                {successMessage != "" &&
                    <div>
                        <span className="success">
                            <span className="material-symbols-rounded success mt-xs fill">
                                check_circle
                            </span>
                            {successMessage}
                        </span>
                    </div>
                }
                {!showOtpBlock ?
                    ""
                    :
                    (<>
                        <span className="mb-12">
                            <input
                                type="text"
                                value={otp}
                                maxLength="4"
                                minLength="4"
                                placeholder="Enter OTP"
                                pattern="\d{4}"
                                onChange={handleOtpChange}
                            />
                        </span>

                        {errorMessage != "" &&
                            <div>
                        <span className="error">
                            <span className="material-symbols-rounded error mt-xs fill">
                                info
                            </span>
                            {errorMessage}
                        </span>
                            </div>
                        }


                        <span>
                            <button
                                type="button"
                                onClick={onOtpSubmit}
                                className="btn seco fullW"
                            >
                                Verify Otp
                            </button>
                        </span>
                    </>)
                }



            </div>
    );
}

export default VerifyPhoneNumber;